/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type MoneyRaisedContainer_app$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchPageContainer_app$ref: FragmentReference;
export type SearchPageContainer_app = {|
  +moneyRaised: ?number,
  +$fragmentRefs: MoneyRaisedContainer_app$ref,
  +$refType: SearchPageContainer_app$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchPageContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "moneyRaised",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "MoneyRaisedContainer_app",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '32de0e65a1d97d3c2ea4117adbe0c037';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Search/__generated__/SearchPageContainer_app.graphql.js